// extracted by mini-css-extract-plugin
export default {"root":"gtttHmIcFdovL5fA1iWV","placeHolderShimmer":"le2cMjJhzJEEHn0DL85g"};